// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-rootwidget .shift-production-container[data-v-54ae03ec] {\n  position: relative;\n  padding-top: 0.5rem;\n  padding-left: 0;\n  width: calc(100% - 1rem);\n  margin-top: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
